<div class="account-shell__content">
  <div class="account-shell__content-wrapper pl-3 pr-3">
<div class="performer-venue-applications">
  <div class="performer-venue-applications__filters grid align-items-end mb-4">
    <div class="col-3 col-sm-12">
      <div class="ui-input__placeholder"><p>С</p></div>
      <div class="ui-input ui-input__text"><input type="date" [(ngModel)]="from" /></div>
    </div>
    <div class="col-3 col-sm-12">
      <div class="ui-input__placeholder"><p>По</p></div>
      <div class="ui-input ui-input__text"><input type="date" [(ngModel)]="to" /></div>
    </div>
    <div class="col-3 col-sm-12">
      <div class="ui-input__placeholder"><p>Статус</p></div>
      <p-dropdown [(ngModel)]="status" [options]="statusOptions" optionLabel="name" optionValue="value" placeholder="Все статусы" styleClass="p-dropdown__bulletins"></p-dropdown>
    </div>
    <div class="col-3 col-sm-12 performer-venue-applications__filter-actions">
      <button type="button" class="ui-buttons ui-buttons__blue-small mr-2" (click)="onApplyFilters()">Применить</button>
      <button type="button" class="ui-buttons ui-buttons__light-small" (click)="onResetFilters()">Сбросить</button>
    </div>
  </div>

  <p class="txt-caption performer-venue-applications__error mb-3" *ngIf="loadError">{{ loadError }}</p>
  <div class="ui-loader ui-loader__page-light" *ngIf="loading"></div>
  <p class="txt-caption" *ngIf="!loading && !items.length && !loadError">Заявок в заведения пока нет.</p>

  <div class="performer-venue-applications__list" *ngIf="!loading && items.length">
    <div class="performer-venue-applications__card mb-3" *ngFor="let item of items">
      <div class="performer-venue-applications__row">
        <a *ngIf="venueProfileLink(item) as link" [routerLink]="link" class="performer-venue-applications__avatar-wrap">
          <img *ngIf="venuePhoto(item) as src" [src]="src" alt="" class="performer-venue-applications__avatar" />
          <div *ngIf="!venuePhoto(item)" class="performer-venue-applications__avatar performer-venue-applications__avatar-placeholder">
            <i class="pi pi-building"></i>
          </div>
        </a>
        <div class="performer-venue-applications__body">
          <h5 class="m-0">
            <a *ngIf="venueProfileLink(item) as vlink" [routerLink]="vlink">{{ venueName(item) }}</a>
            <span *ngIf="!venueProfileLink(item)">{{ venueName(item) }}</span>
          </h5>
          <p class="txt-caption mb-1">Статус: {{ statusLabel(item.status) }}</p>
          <p class="txt-caption mb-1">Отправлена: {{ formatDate(item.createdAt) }}</p>
          <p class="mb-2" *ngIf="item.message">{{ item.message }}</p>
          <button
            type="button"
            class="ui-buttons ui-buttons__light-small"
            *ngIf="canWithdraw(item)"
            [disabled]="actionLoadingId === item.requestId"
            (click)="withdraw(item)">
            Отозвать
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="performer-venue-applications__pager mt-3" *ngIf="!loading && (page > 1 || hasMore)">
    <button type="button" class="ui-buttons ui-buttons__light-small mr-2" [disabled]="page <= 1" (click)="onPrevPage()">Назад</button>
    <span class="txt-caption mr-2">Стр. {{ page }}</span>
    <button type="button" class="ui-buttons ui-buttons__light-small" [disabled]="!hasMore" (click)="onNextPage()">Далее</button>
  </div>
</div>

<p-confirmDialog [appendTo]="'body'" [styleClass]="'p-dialog__confirm'"></p-confirmDialog>
  </div>
</div>
